module.exports = hasKeys

function hasKeys(source) {
    return source !== null &&
        (typeof source === "object" ||
        typeof source === "function")
}



//////////////////
// WEBPACK FOOTER
// ./~/value-event/~/xtend/has-keys.js
// module id = 174
// module chunks = 0